import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import SideBar from "../other/SideBar";
import NavBar from "../other/NavBar";
import {
    applyCouponUrl,
    createRazorpayPayOrderId,
    GetFoodersPlansDetails,
    razorpay_id,
    razorpayCheckout,
    updateFoodersPlans,
} from "../../assets/api/BaseURL";
import LoadingModal from "../../loader/LoadingModal";
import Notification from "../other/Notification";
import axios from "axios";
import { useToast } from "../../../context/ToastContext";

const VarUpdates = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { addToast } = useToast();

    const { setPlan } = useToast();

    const [token, setToken] = useState("");
    const [toggleSideBar, setToggleSideBar] = useState(false);
    const [canvas, setCanvas] = useState(false);
    const [currencySymbol, setCurrencySymbol] = useState("");


    const [isLoading, setIsLoading] = useState(false);


    const handleToggleSidebar = (e) => {
        e.preventDefault();
        setToggleSideBar(!toggleSideBar);
    };

    const handleToggleOffCanvas = (e) => {
        e.preventDefault();
        setCanvas(!canvas);

    };


    function changeDateFormat(dateStr) {
        const [year, month, day] = dateStr?.split("-");
        return `${day}/${month}/${year}`;
    }

    /** UI-only: ISO `YYYY-MM-DD` → "02 Apr 2025". Does not alter API date values. */
    function displayPlanDate(dateStr) {
        if (!dateStr) return "";
        const parts = String(dateStr).split("-");
        if (parts.length !== 3) {
            return changeDateFormat(dateStr);
        }
        const [year, month, day] = parts;
        const y = parseInt(year, 10);
        const m = parseInt(month, 10);
        const d = parseInt(day, 10);
        if (!y || !m || !d) {
            return changeDateFormat(dateStr);
        }
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const dd = String(d).padStart(2, "0");
        return `${dd} ${months[m - 1]} ${y}`;
    }





    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/auth");
        }
    }, [navigate]);

    useEffect(() => {
        setToken(localStorage.getItem("token"));
        setCurrencySymbol(localStorage.getItem("currencySymbol"));
        // console.log(toggleSideBar)
    }, [token]);




    const [fooderActivePlansData, setFooderActivePlansData] = useState({});

    const [fooderPrevisePaymentDetails, setFooderPrevisePaymentDetails] = useState([]);

    const [addGoldPlanPrice, setAddGoldPlanPrice] = useState(false);






    useEffect(() => {
        if (token) {
            async function getData() {
                setIsLoading(true);
                try {
                    const response = await axios.get(GetFoodersPlansDetails, {
                        headers: { authorization: `Bearer ${token}` },
                    });

                    if (response.status === 200 && response.data.data) {

                        console.log(response.data.data)
                        setFooderActivePlansData(response.data.data)

                        setFooderPrevisePaymentDetails(response.data.payment_details)
                        setAddGoldPlanPrice(parseFloat(response.data.data.gold_plans_price))
                        setFormData(response.data.fooders_details)

                    }
                } catch (error) {
                    if (error.response && error.response.data.message) {
                        addToast("error", error.response.data.message);
                    } else {
                        addToast("error", error.message);
                    }
                    console.log(error);
                }
                setIsLoading(false);
            }


            getData();

        }
    }, [token, addToast]);

    const [paymentDetailsData, setPaymentDetailsData] = useState({});
    const [paymentDetailsFooderData, setPaymentDetailsFooderData] = useState({});
    const [paymentDetailsShow, setPaymentDetailsShow] = useState(false);

    const createPaymentDetails = (headingStep, planPrice, paymentData, fooderDetails, gstRate) => {

        let tempData = JSON.parse(paymentData)
        let tempFooderDetails = JSON.parse(fooderDetails)
        let mainPrice = parseFloat(planPrice)

        let DiscountRate = 0
        let DiscountType = 0

        if (tempFooderDetails?.coupon?.amount) {
            console.log(tempFooderDetails.coupon)
            DiscountRate = parseFloat(tempFooderDetails.coupon.amount)
            DiscountType = parseInt(tempFooderDetails.coupon.type)

        }



        let amount_without_gst = mainPrice / ((parseFloat(gstRate) / 100) + 1)
        // let amount_without_gst = mainPrice / 1.18


        let discount = 0
        let afterdiscount = 0
        let gst = 0
        let total = 0



        if (DiscountType === 0) {
            discount = amount_without_gst * (DiscountRate / 100);
            afterdiscount = amount_without_gst - discount;

        } else {
            discount = parseFloat(DiscountRate);
            afterdiscount = amount_without_gst - discount;

        }
        gst = afterdiscount * (parseFloat(gstRate) / 100);

        total = amount_without_gst - discount + gst

        setPaymentDetailsFooderData(JSON.parse(fooderDetails))

        // const gstRate = 0.18; // Define GST rate as a constant for better maintainability

        const paymentDetailsData = {

            payment_id: tempData.id,
            method: tempData.method,

            amount_without_gst: amount_without_gst.toFixed(2),

            discount: discount.toFixed(2),
            discount_type: DiscountType,
            discount_rate: DiscountRate,


            gst: gst.toFixed(2),


            amount_with_gst: total.toFixed(2),
        };



        setPaymentDetailsData(paymentDetailsData)
        setPaymentDetailsShow(true)


    };



    const [upgradePlaneShow, setUpgradePlaneShow] = useState(false);

    const [formData, setFormData] = useState({});

    const [couponName, setCouponName] = useState("");
    const [couponDeatils, setCouponDeatils] = useState({});
    const [couponType, setCouponType] = useState(0);
    const [couponRate, setCouponRate] = useState(0);


    const [subTotal, setSubTotal] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [gstAmount, setGstAmount] = useState(0);
    const [total, setTotal] = useState(0);


    useEffect(() => {

        let subTotal = 0
        let discount = 0
        let afterdiscount = 0

        let gst = 0
        let total = 0



        if (addGoldPlanPrice) {
            subTotal += parseFloat(addGoldPlanPrice) / 1.18
        }


        if (couponDeatils && subTotal > 0) {
            if (couponType === 0) {
                discount = subTotal * (couponRate / 100);
                afterdiscount = subTotal - discount;
            } else {
                discount = parseFloat(couponRate);
                afterdiscount = subTotal - discount;
            }
        }

        gst = afterdiscount * (18 / 100);

        total = subTotal - discount + gst

        if (total < 0) {
            total = 0
        }
        setSubTotal(subTotal)
        setDiscount(discount)
        setGstAmount(gst)
        setTotal(total)


    }, [addGoldPlanPrice, couponRate]);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // console.log(e.target.value)
        setFormData({
            ...formData,
            [name]: value,
        });



    };

    const applyCoupon = async () => {

        console.log(formData)

        if (subTotal) {
            try {
                setIsLoading(true)
                const response = await axios({
                    method: "post",
                    url: applyCouponUrl,
                    data: {
                        couponName: couponName,
                        amount: subTotal

                    },
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${token}`,
                    },
                });


                if (response.data.couponData) {
                    setCouponDeatils(response.data.couponData)
                    setCouponType(response.data.couponData.type)
                    setCouponRate(response.data.couponData.amount)
                    addToast("success", response.data.message);



                    // Remove the canvas element after 5 seconds



                } else {
                    addToast("error", response.data.message);

                    setCouponDeatils({})
                    setCouponType(0)
                    setCouponRate(0)
                }





            } catch (error) {
                setCouponDeatils({})
                setCouponType(0)
                setCouponRate(0)
                if (error.response && error.response.data.message) {
                    addToast("error", error.response.data.message);
                } else {
                    addToast("error", error.message);
                }
                console.log(error);
                setIsLoading(false)
            }
            setIsLoading(false);
        } else {
            addToast("error", "Add a plan total before applying a promo code.");
        }






    };







    const handlePayment = async () => {

        // console.log(formData)

        let totalAmount = total

        if (total > 0) {




            const res = await loadRazorpayScript();
            // UpgradeFooderPlan({ razorpay_payment_id: "pay_PeA8ik84r7IvCx", order_id: "pay_PeA8ik84r7sdIvCx" })
            if (res) {

                try {
                    setIsLoading(true)
                    // totalAmount already includes GST, so use it directly
                    const finalTotalAmount = parseFloat(totalAmount);
                    console.log('Creating Razorpay order with details:', {
                        baseAmount: totalAmount,
                        gstAmount: gstAmount,
                        finalTotal: finalTotalAmount,
                        finalTotalInPaise: parseInt(finalTotalAmount * 100),
                        note: 'totalAmount already includes GST'
                    });
                    console.log('createRazorpayPayOrderId URL:', createRazorpayPayOrderId);

                    const response = await axios({
                        method: "post",
                        url: createRazorpayPayOrderId,
                        data: {
                            total: parseInt(finalTotalAmount * 100)
                        },
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `Bearer ${token}`,
                        },
                    });

                    console.log('Full Response:', response);
                    console.log('Response Data:', response.data);

                    const responseData = response.data;
                    const orderData = responseData.order; // Fix: Get order from response.data.order
                    console.log('Order Data:', orderData); // Debug log

                    if (!responseData || responseData.status !== 'success' || !orderData || !orderData.id) {
                        throw new Error('Invalid order data received from server');
                    }




                    const options = {
                        key: razorpay_id, // Replace with your Razorpay Key ID
                        amount: parseInt(finalTotalAmount * 100), // Use final total with GST
                        currency: "INR",
                        name: "VYQDA",
                        description: "Plan Transaction",
                        order_id: orderData.id,
                        prefill: {
                            name: formData.name,
                            email: formData.email,
                            contact: formData.phone_no
                        },
                        handler: (response) => {
                            console.log('Razorpay Response:', response); // Debug log

                            // Use exact response values without modification
                            const paymentData = {
                                razorpay_payment_id: response.razorpay_payment_id,
                                razorpay_signature: response.razorpay_signature,
                                order_id: orderData.id // Use original order ID from our order creation
                            };

                            console.log('Payment Data to Send:', paymentData);

                            // Call your function to upgrade the plan with complete payment data
                            UpgradeFooderPlan(paymentData);
                        },
                    };


                    const rzp = new window.Razorpay(options);
                    rzp.open();


                } catch (error) {
                    if (error.response && error.response.data.message) {
                        addToast("error", error.response.data.message);
                    } else {
                        addToast("error", error.message);
                    }
                    console.log(error);
                    setIsLoading(false)
                }
                setIsLoading(false);

            }
        } else {
            addToast("error", "Choose a plan with a payable total to continue.");
        }
    };



    const UpgradeFooderPlan = async (razorpayOrderData) => {
        setIsLoading(true)

        console.log(razorpayOrderData)

        let temp_form_data = { ...formData }

        temp_form_data.coupon = couponDeatils



        let dataToSend = {
            goldPlanPrice: addGoldPlanPrice ? 1 : 0,


            goldPlanPriceAmount: addGoldPlanPrice,

            fooder_details: temp_form_data,
            gst_rate: 18,
            gst_amount: parseFloat(gstAmount).toFixed(2),
            razorpayOrderData
        }
        console.log(dataToSend)

        try {

            const res = await axios({
                method: "post",
                url: updateFoodersPlans,
                data: dataToSend,
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${token}`,
                },
            });
            localStorage.setItem("planDetails", JSON.stringify(res.data.plan));


            setPlan(res.data.plan);
            addToast("success", res.data.message);

            setTimeout(function () {
                window.location.reload();
            }, 3000);


        } catch (error) {
            if (error.response && error.response.data.message) {
                addToast("error", error.response.data.message);
            } else {
                addToast("error", error.message);
            }
            console.log(error);
            setIsLoading(false)

        }


    };

    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = razorpayCheckout;
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    /** Display-only: keeps currency and amount readable (e.g. avoids "Fr1" sticking together) */
    const formatMoneyLabel = (symbol, amount) => {
        if (amount === null || amount === undefined || Number.isNaN(Number(amount))) {
            return "—";
        }
        const sym = symbol && String(symbol).trim() ? `${String(symbol).trim()}\u00a0` : "";
        const n = Number(amount);
        return `${sym}${n.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 0 })}`;
    };

    /** Payment history row only: symbol + amount with no space (e.g. $6,999). */
    const formatPaymentAmountDisplay = (symbol, amount) => {
        if (amount === null || amount === undefined || Number.isNaN(Number(amount))) {
            return "—";
        }
        const sym = symbol && String(symbol).trim() ? String(symbol).trim() : "";
        const n = Number(amount);
        return `${sym}${n.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 0 })}`;
    };

    const shouldShowPaymentNote = (note) => {
        if (note == null) return false;
        const t = String(note).trim();
        if (!t) return false;
        return t.toLowerCase() !== "null";
    };






    return (
        <>
            {token && (
                <>
                    <div
                        className={
                            toggleSideBar
                                ? "container-scroller sidebar-icon-only"
                                : "container-scroller"
                        }
                    >
                        <nav className="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row">
                            <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
                                <Link className="navbar-brand brand-logo-mini" to="/fooders_cp">
                                    {/* <img src="images/mini-kr-logo.svg" alt="logo" />     */}
                                </Link>
                                <div className="me-1">
                                    <button
                                        className={
                                            toggleSideBar
                                                ? "navbar-toggler navbar-toggler align-self-center"
                                                : "navbar-toggler navbar-toggler align-self-center text-white"
                                        }
                                        type="button"
                                        onClick={handleToggleSidebar}
                                    >
                                        <span className="icon-menu"></span>
                                    </button>
                                </div>
                                <div>
                                    <Link to="/fooders_cp">
                                        <span className="navbar-brand brand-logo">
                                            <img src="images/vyfoo_logo.png" alt="logo" />
                                        </span>
                                    </Link>
                                </div>
                            </div>
                            <NavBar handleToggle={handleToggleOffCanvas} toggleCanvas={toggleSideBar} />
                        </nav>
                        <div className="container-fluid page-body-wrapper px-0">
                            <SideBar active="upgrade_plan" toggleCanvas={toggleSideBar} />

                            <div className="main-panel">
                                <div className="content-wrapper vyfoo-upgrade-plans">


                                    <div className="row">
                                        <div className="col-sm-12">

                                            <header className="vyfoo-upgrade-hero mb-4">
                                                <p className="vyfoo-upgrade-eyebrow mb-2">Plans &amp; billing</p>
                                                <h1 className="vyfoo-upgrade-title">Manage your subscription</h1>
                                                <p className="vyfoo-upgrade-lead text-muted mb-0">
                                                    View your plan details and billing information below.
                                                </p>
                                            </header>

                                            <div className="mb-4">
                                                <div className="card vyfoo-current-plan-card border-0 shadow-sm">
                                                    <div className="card-body p-4 p-lg-4">
                                                        <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-4">
                                                            <div className="flex-grow-1">
                                                                <p className="vyfoo-upgrade-eyebrow mb-2">Current subscription</p>
                                                                <h2 className="h4 fw-bold mb-0 vyfoo-current-plan-heading">
                                                                    You&apos;re on the{" "}
                                                                    <span
                                                                        className={
                                                                            fooderActivePlansData.current_plan === 4
                                                                                ? "text-warning"
                                                                                : "text-secondary"
                                                                        }
                                                                    >
                                                                        {fooderActivePlansData.current_plan === 4 ? "Gold" : "Free"}
                                                                    </span>{" "}
                                                                    plan
                                                                </h2>
                                                                <p className="text-muted small mt-2 mb-0">
                                                                    {fooderActivePlansData.current_plan === 4
                                                                        ? "POS, kitchen, inventory, and reporting features are included."
                                                                        : "You can run menus and tables on Free. Upgrade when you need POS, inventory, and advanced reports."}
                                                                </p>
                                                            </div>
                                                            {fooderActivePlansData.current_plan === 1 && (
                                                                <div className="flex-shrink-0">
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => setUpgradePlaneShow(true)}
                                                                        className="btn btn-primary vyfoo-btn-upgrade px-4 py-2"
                                                                    >
                                                                        {fooderPrevisePaymentDetails.length > 0
                                                                            ? "Continue to Gold"
                                                                            : "View plans & upgrade"}
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>

                                                        {fooderActivePlansData.current_plan === 4 && (
                                                            <>
                                                                <hr className="vyfoo-upgrade-divider my-4" />
                                                                <p className="small mb-3 vyfoo-current-plan-features-title">
                                                                    Included in the Gold plan
                                                                </p>
                                                                <div className="row">
                                                                    {[
                                                                        "POS",
                                                                        "Kitchen Display System (KDS)",
                                                                        "Staff Management",
                                                                        "Order Management",
                                                                        "Inventory management",
                                                                        "Customer management",
                                                                        "Table management",
                                                                        "QR code ordering",

                                                                        "Promotions",
                                                                        "Reports",
                                                                    ].map((feature) => (
                                                                        <div className="col-12 col-sm-6 col-md-4 mb-2" key={feature}>
                                                                            <div className="d-flex align-items-start vyfoo-feature-row">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked
                                                                                    readOnly
                                                                                    className="vyfoo-feature-check"
                                                                                    aria-hidden
                                                                                />
                                                                                <span className="text-muted small">{feature}</span>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>

                                                                <div className="row g-3 vyfoo-current-plan-dates-row">
                                                                    <div className="col-md-6">
                                                                        <p className="mb-0 small text-dark">
                                                                            <span className="fw-semibold">Start date:</span>{" "}
                                                                            {displayPlanDate(fooderActivePlansData?.plan_upgrade_date)}
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <p className="mb-0 small vyfoo-renewal-date-text">
                                                                            <span className="fw-semibold">Renewal date:</span>{" "}
                                                                            {displayPlanDate(fooderActivePlansData?.plan_expire_date)}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    {upgradePlaneShow ? <>


                                        <div className="row align-items-stretch">





                                            {/* FREE PLAN */}
                                            <div className="col-12 col-md-6 my-2">
                                                <div className="plan-card free-plan vyfoo-plan-tile vyfoo-plan-tile--free">

                                                    <div className="current-badge">Current plan</div>

                                                    <div className="vyfoo-plan-tile__top">
                                                        <h2 className="plan-title free mb-0">Free</h2>
                                                        <p className="plan-sub">Basic features to get started.</p>
                                                    </div>

                                                    <div className="vyfoo-plan-tile__features">
                                                        <p className="vyfoo-plan-tile__section-label">Included features</p>
                                                        <div className="feature-list">
                                                            <h6><i className="mdi mdi-checkbox-marked-circle feature-icon" aria-hidden="true"></i> Business &amp; outlet settings</h6>
                                                            <h6><i className="mdi mdi-checkbox-marked-circle feature-icon" aria-hidden="true"></i> Menu &amp; dishes</h6>
                                                            <h6><i className="mdi mdi-checkbox-marked-circle feature-icon" aria-hidden="true"></i> Table layout management</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* GOLD PLAN */}
                                            <div className="col-12 col-md-6 my-2">
                                                <div className="plan-card gold-plan vyfoo-plan-tile vyfoo-plan-tile--gold">
                                                    <div className="vyfoo-plan-tile__top">
                                                        <h2 className="plan-title gold mb-0"><span className="fw-bold">Gold</span></h2>
                                                        <p className="plan-sub">POS, kitchen screens, inventory, customers, and analytics in one place.</p>
                                                    </div>

                                                    <div className="vyfoo-plan-tile__price-band">
                                                        <p className="price vyfoo-plan-price mb-0">
                                                            <span className="vyfoo-plan-price__label text-muted small d-block mb-1">Price</span>
                                                            <span className="vyfoo-plan-price__line">
                                                                <span className="vyfoo-plan-price__value">{formData.country === "IN" ? "₹" :"$"} {addGoldPlanPrice}</span>
                                                                <span className="vyfoo-plan-price__period"> / year</span>
                                                            </span>
                                                            <span className="vyfoo-plan-price__billing-note">Billed annually</span>
                                                            <span className="vyfoo-plan-price__duration-note">Valid for 12 months</span>
                                                        </p>
                                                    </div>

                                                    <div className="vyfoo-plan-tile__features">
                                                        <p className="vyfoo-plan-tile__section-label">Includes everything in the Free plan, plus</p>
                                                        <div className="feature-list">

                                                            <h6><i className="mdi mdi-checkbox-marked-circle feature-icon" aria-hidden="true"></i> POS</h6>
                                                            <h6><i className="mdi mdi-checkbox-marked-circle feature-icon" aria-hidden="true"></i> Kitchen Display System (KDS)</h6>
                                                            <h6><i className="mdi mdi-checkbox-marked-circle feature-icon" aria-hidden="true"></i> Staff Management</h6>
                                                            <h6><i className="mdi mdi-checkbox-marked-circle feature-icon" aria-hidden="true"></i> Order Management</h6>
                                                            <h6><i className="mdi mdi-checkbox-marked-circle feature-icon" aria-hidden="true"></i> Inventory management</h6>

                                                            <h6><i className="mdi mdi-checkbox-marked-circle feature-icon" aria-hidden="true"></i> Customer management</h6>
                                                            <h6><i className="mdi mdi-checkbox-marked-circle feature-icon" aria-hidden="true"></i> Table management</h6>
                                                            <h6><i className="mdi mdi-checkbox-marked-circle feature-icon" aria-hidden="true"></i> QR code ordering</h6>
                                                            <h6><i className="mdi mdi-checkbox-marked-circle feature-icon" aria-hidden="true"></i> Promotions</h6>
                                                            <h6><i className="mdi mdi-checkbox-marked-circle feature-icon" aria-hidden="true"></i> Reports</h6>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
















                                            <div className="col-lg-6 my-2">
                                                <div className="card card-rounded vyfoo-billing-card border-0 shadow-sm">
                                                    <div className="card-body trcnt p-4">
                                                        <div className="row">
                                                            <div className="col-12 mb-3">
                                                                <h4 className="h5 fw-bold mb-1">Billing details</h4>
                                                                <p className="text-muted small mb-0">Shown on your invoice. Use the legal name for your business where required.</p>
                                                            </div>

                                                            <div className="col-lg-6">
                                                                <div className="form-group">
                                                                    <label>
                                                                        Full name
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Name on invoice"
                                                                        name="name"
                                                                        value={formData.name}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-6">
                                                                <div className="form-group">
                                                                    <label>
                                                                        Business name
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Registered or trading name"
                                                                        name="business_name"
                                                                        value={formData.business_name}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-6">
                                                                <div className="form-group">
                                                                    <label>
                                                                        Email
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="name@company.com"
                                                                        name="email"
                                                                        value={formData.email}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-6">
                                                                <div className="form-group">
                                                                    <label>
                                                                        Phone
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Include country code"
                                                                        name="phone_no"
                                                                        value={formData.phone_no}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-6">
                                                                <div className="form-group">
                                                                    <label>
                                                                        Address
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Street, city, postal code"
                                                                        name="address"
                                                                        value={formData.address}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {formData.country === "IN" ?

                                                                <div className="col-lg-6">
                                                                    <div className="form-group">
                                                                        <label>
                                                                            Tax ID (GST / VAT)
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="If applicable"
                                                                            name="gst"
                                                                            value={formData.gst}
                                                                            onChange={handleInputChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                : <></>}




                                                        </div>
                                                    </div>
                                                </div>
                                            </div>



                                            <div className="col-lg-6 grid-margin">

                                                <div className={'my-2'}>
                                                    <div className="card card-rounded vyfoo-promo-card border-0 shadow-sm">
                                                        <div className="card-body trcnt p-4">
                                                            <label className="fw-semibold mb-2 d-block">
                                                                Promo code
                                                            </label>
                                                            <p className="text-muted small mb-3">Have a code from your Vyfoo contact? Apply it before you pay.</p>

                                                            <div className="row my-2">

                                                                <div className="col-lg-9">
                                                                    <div className="form-group">

                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Enter code"
                                                                            name="email"
                                                                            value={couponName}
                                                                            onChange={(e) => { setCouponName(e.target.value) }}
                                                                        />
                                                                    </div>

                                                                </div>



                                                                <div className="col-lg-3">
                                                                    {discount ?
                                                                        <button type="button" className="btn btn-outline-danger me-2 w-100 w-lg-auto" onClick={() => {
                                                                            setCouponDeatils({});
                                                                            setCouponRate(0);
                                                                            setCouponType(0);
                                                                            setCouponName('')


                                                                        }}>
                                                                            Remove
                                                                        </button> :
                                                                        <button type="button" className="btn btn-primary me-2 w-100 w-lg-auto" onClick={applyCoupon}>
                                                                            Apply
                                                                        </button>
                                                                    }

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={'my-2'}>
                                                    <div className="card card-rounded vyfoo-payment-card border-0 shadow-sm">
                                                        <div className="card-body trcnt p-4">
                                                            <h4 className="h5 fw-bold mb-1">Order summary</h4>
                                                            <p className="text-muted small mb-4">Taxes shown follow your workspace settings at checkout.</p>

                                                            <div className="totaldiv wrapper d-flex align-items-center justify-content-between">
                                                                <div className="d-flex">
                                                                    <div className="wrapper">
                                                                        <h5 className="totalwrd mb-0">Subtotal</h5>
                                                                    </div>
                                                                </div>
                                                                <div className="">
                                                                    <h5 className="mb-0 fw-semibold">{formData.country === "IN" ? "₹" :"$"} { parseFloat(subTotal).toFixed(2)}</h5>
                                                                </div>
                                                            </div>

                                                            <div className="totaldiv wrapper d-flex align-items-center justify-content-between">
                                                                <div className="d-flex">
                                                                    <div className="wrapper">
                                                                        <h5 className="totalwrd mb-0">Discount
                                                                            {couponType === 0 && subTotal !== 0 ? ` (${couponRate}%)` : ""}
                                                                        </h5>
                                                                    </div>
                                                                </div>
                                                                <div className="">
                                                                    <h5 className="mb-0 fw-semibold">{formData.country === "IN" ? "₹" :"$"} {   parseFloat(discount).toFixed(2)}</h5>
                                                                </div>

                                                            </div>

                                                            {gstAmount > 0 ? <>
                                                                <div className="totaldiv wrapper d-flex align-items-center justify-content-between">
                                                                    <div className="d-flex">
                                                                        <div className="wrapper">
                                                                            <h5 className="totalwrd mb-0">Tax (18%)</h5>
                                                                        </div>
                                                                    </div>
                                                                    <div className="">
                                                                        <h5 className="mb-0 fw-semibold">{formData.country === "IN" ? "₹" :"$"}  {parseFloat(gstAmount).toFixed(2)}  </h5>
                                                                    </div>

                                                                </div>


                                                            </> : <></>}

                                                            <div className="totaldiv wrapper d-flex align-items-center justify-content-between vyfoo-total-row">
                                                                <div className="d-flex">
                                                                    <div className="wrapper">
                                                                        <h5 className="totalwrd mb-0">Total due</h5>
                                                                    </div>
                                                                </div>
                                                                <div className="">
                                                                    <h5 className="mb-0 fw-bold">{formData.country === "IN" ? "₹" :"$"}  {parseFloat(total).toFixed(2)} </h5>
                                                                </div>
                                                            </div>
                                                            <br />

                                                            <div className="text-center">
                                                                <button type="button" className="btn vyfoo-pay-now-btn px-5 py-2" onClick={handlePayment}>
                                                                    Pay now {formData.country === "IN" ? "₹" :"$"}  {parseFloat(total).toFixed(2)} 
                                                                </button>
                                                            </div>

                                                        </div>


                                                    </div>


                                                </div>
                                            </div>

                                        </div>
                                    </> : <></>}







                                    {fooderPrevisePaymentDetails.length > 0 && (
                                        <h3 className="h5 fw-semibold mt-4 mb-3 vyfoo-history-title">Payment history</h3>
                                    )}

                                    {
                                        fooderPrevisePaymentDetails.map((item, index) => (

                                            <div className={'my-2'} key={index}>
                                                <div className="card card-rounded vyfoo-history-card border-0 shadow-sm">
                                                    <div className="card-body trcnt p-4">
                                                        <div className="row align-items-md-center g-3 vyfoo-history-card__inner">
                                                            <div className="col-12 col-md">
                                                                <h6 className="update-ver-color mb-1 vyfoo-history-card__plan"><span className="fw-bold">Gold plan</span></h6>
                                                                <h6 className="mb-2 vyfoo-history-card__amount">
                                                                    <span className="text-muted small fw-normal">Amount: </span>
                                                                    <span className="text-body fw-semibold">{formData.country === "IN" ? "₹" :"$"} { item.fooder_plan_price }</span>
                                                                </h6>

                                                                <p className="text-muted small mb-0 vyfoo-history-card__paid"><span className="fw-semibold text-body">Paid on</span> {displayPlanDate(item.plan_upgrade_date)}</p>
                                                                {shouldShowPaymentNote(item.note_comment) ? (
                                                                    <p className="text-danger small mt-2 mb-0"><span className="fw-semibold">Note:</span> {item.note_comment}</p>
                                                                ) : null}

                                                            </div>

                                                            <div className="col-12 col-md-auto text-md-end">
                                                                <button type="button" onClick={() => { createPaymentDetails("gold", item.fooder_plan_price, item.payment_data, item.fooder_details, item.gst_rate) }} className="btn btn-sm vyfoo-view-receipt-btn">
                                                                    View receipt
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }






                                </div>
                            </div>











                        </div>

                        <div
                            className={paymentDetailsShow ? "modal fade show d-block" : "modal fade"}
                            tabIndex={-1}
                            role="dialog"
                            aria-labelledby="exampleModalLabel"
                            aria-hidden="true"

                        >
                            <div className="modal-dialog   " role="document" style={{ height: "450px", minWidth: "70vw" }} >

                                <div className="modal-content w-85" >
                                    <div className="modal-header py-2">
                                        <h5 className="modal-title" id="exampleModalLabel">
                                            Receipt details
                                        </h5>

                                        <button
                                            type="button"
                                            className="close"
                                            data-dismiss="modal"
                                            aria-label="Close"
                                            onClick={() => { setPaymentDetailsShow(false) }}
                                        >
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body py-2" >
                                        <div className="container-fluid">
                                            <h2>{paymentDetailsData.plan_name}</h2>
                                            {paymentDetailsData.payment_id ? <h6>Payment Id: {paymentDetailsData.payment_id}</h6> : <></>}
                                            <h6>Method: {paymentDetailsData.method}</h6>
                                            <h6>Base Price: {paymentDetailsData.amount_without_gst}</h6>
                                            {paymentDetailsData.discount > 0 ? <h6>Coupon{paymentDetailsData.discount && paymentDetailsData.discount_type === 0 ? `(${paymentDetailsData.discount_rate}%)` : ""}: {paymentDetailsData.discount}</h6> : <></>}
                                            {paymentDetailsData.gst > 0 ? <h6> {formData.country === "IN" ? "GST(18%)" : "Tax(18%)"} {formData.country === "IN" ? "₹" :"$"}{paymentDetailsData.gst}</h6> : <></>}
                                            <h6>Total Amount: {formData.country === "IN" ? "₹" :"$"}{paymentDetailsData.amount_with_gst}</h6>
                                            <hr />
                                            <div className="row">
                                                <div className="col-12 d-flex justify-content-between">
                                                    <div className="col-6">
                                                        <h3 className="update-ver-color"><b>Billing Details</b></h3>
                                                        {paymentDetailsFooderData.name ? <h6>  Name: {paymentDetailsFooderData.name}</h6> : <></>}
                                                        {paymentDetailsFooderData.business_name ? <h6>  Business Name: {paymentDetailsFooderData.business_name}</h6> : <></>}
                                                        {paymentDetailsFooderData.email ? <h6>  Email: {paymentDetailsFooderData.email}</h6> : <></>}
                                                        {paymentDetailsFooderData.phone_no ? <h6>  Phone No: {paymentDetailsFooderData.phone_no}</h6> : <></>}
                                                        {paymentDetailsFooderData.address ? <h6>  Address: {paymentDetailsFooderData.address}</h6> : <></>}
                                                        {paymentDetailsFooderData.gst && formData.country === "IN" ? <h6>  GST No: {paymentDetailsFooderData.gst}</h6> : <></>}
                                                    </div>
                                                    <div className="col-6">
                                                        <h3>VYQDA TECHNOLOGIES PRIVATE LIMITED   </h3>
                                                        <h6>GST No: 09AAKCV1770H1Z0    </h6>
                                                        <h6>Address: 87 SHIVAJI NAGAR, Agra, Uttar Pradesh, 282010   </h6>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>



                                    <div className="modal-footer py-1">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            data-dismiss="modal"
                                            onClick={() => { setPaymentDetailsShow(false) }}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>

                    <LoadingModal isLoading={isLoading} />

                    <Notification />
                </>
            )}
        </>
    );
};

export default VarUpdates;